
export type RequestStateType = typeof RequestStateType[keyof typeof RequestStateType];


export const RequestStateType = {
  Invited: 'Invited',
  DataInput: 'DataInput',
  DataVerification: 'DataVerification',
  AdditionalDataInput: 'AdditionalDataInput',
  CoreSystemActivation: 'CoreSystemActivation',
  ContractSigning: 'ContractSigning',
  SignatureVerification: 'SignatureVerification',
  ServiceActivation: 'ServiceActivation',
  Completed: 'Completed',
  Declined: 'Declined',
  Aborted: 'Aborted',
  ShopActivationCompleted: 'ShopActivationCompleted',
  CompletedWithoutMyDoka: 'CompletedWithoutMyDoka',
  Expired: 'Expired',
  Doka360AccessRequested: 'Doka360AccessRequested',
} as const;
